import { render, staticRenderFns } from "./ProductListView.vue?vue&type=template&id=07918ab2&scoped=true&"
import script from "./ProductListView.vue?vue&type=script&lang=js&"
export * from "./ProductListView.vue?vue&type=script&lang=js&"
import style0 from "./ProductListView.vue?vue&type=style&index=0&id=07918ab2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07918ab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
